import styles from "./Separator.module.css";

const Separator = () => <hr className={styles.separator} />;

export default Separator;
